import { SMS_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { useThreadListMemberDetails } from 'conversations-thread-data/thread-details/public/hooks';
import { getOriginalGenericChannelId } from 'conversations-thread-data/thread-details/public/operators';
import enviro from 'enviro';
// @ts-expect-error module not typed
import FeedbackLoader from 'feedback-loader';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFocusedViewMemberThreadId } from '../focused-view-member/selectors/getFocusedViewMemberThreadId';
import { useSmsCSATState } from 'composer-ui/reply-editor/public/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const SMS_CSAT_SURVEY_ID_QA = 391;
const SMS_CSAT_SURVEY_ID_PROD = 1135;
const DEBOUNCE_SURVEY_LOAD = 2000;
export function InboxFeedbackLoader() {
  const hasSeenAndIgnoredSurveyRef = useRef(false);
  const [feedbackClient, setFeedbackClient] = useState();
  const threadId = useSelector(getFocusedViewMemberThreadId);
  const {
    shouldDisplaySmsCSAT
  } = useSmsCSATState();
  const {
    data: threadListMember,
    loading
  } = useThreadListMemberDetails({
    threadId: `${threadId}`
  });
  const originalGenericChannelId = /*  @ts-expect-error Jun-7-2024, 15:40UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  getOriginalGenericChannelId(threadListMember);
  useEffect(() => {
    if (!feedbackClient || loading) return;
    if (!hasSeenAndIgnoredSurveyRef.current && shouldDisplaySmsCSAT && originalGenericChannelId === SMS_GENERIC_CHANNEL_ID) {
      hasSeenAndIgnoredSurveyRef.current = true;
      feedbackClient.loadSurvey('CSAT', enviro.isQa() ? SMS_CSAT_SURVEY_ID_QA : SMS_CSAT_SURVEY_ID_PROD);
      feedbackClient.show();
    } else {
      feedbackClient.hide();
    }
  }, [loading, originalGenericChannelId, feedbackClient, shouldDisplaySmsCSAT]);
  return /*#__PURE__*/_jsx(FeedbackLoader, {
    delayMs: DEBOUNCE_SURVEY_LOAD,
    onClientLoad: client => {
      client.onConfigLoaded = () => {
        setFeedbackClient(client);
      };
      client.loadConfigOnly('CSAT', enviro.isQa() ? SMS_CSAT_SURVEY_ID_QA : SMS_CSAT_SURVEY_ID_PROD);
    }
  });
}
InboxFeedbackLoader.displayName = 'InboxFeedbackLoader';